<template>
	<!-- Main Sections -->
	<main class="main-wrapper">
		<section class="error-section py-40" v-if="!item && !loading">
			<div class="container-fluid">
				<div class="error-wrapper text-center py-40 bg-white br-10">
					<h1 class="mb-32">404</h1>
					<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
					<p class="light-gray mb-32">Новость не найдена.<br/>Возможно она была удалена либо никогда не существовала.</p>
					<router-link :to="{path: '/news'}" class="cus-btn">В список новостей</router-link>
				</div>
			</div>
		</section>
		
		<div v-else>
			<!-- Blog Detail Section Start -->
			<section class="blog-detail-section bg-lightest-gray py-40">
				<div class="container-fluid">
					<div class="row row-gap-4">
						<div class="col-md-8 offset-md-2">
							<div class="top-bar mb-16">
								<router-link :to="{path: '/news'}" class="cus-btn-arrow">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<path d="M9.48438 17.25C9.48438 15 7.38438 12 4.98438 12M4.98438 12C6.35938 12 9.48437 11.25 9.48438 6.75M4.98438 12H19.2344" stroke="#141516" stroke-width="1.5"></path>
									</svg>
									Назад к списку новостей
								</router-link>
								<div v-if="authModel.isAdmin()">
									<router-link :to="{path: '/admin/news/'+item?.id}" class="btn btn-sm btn-primary me-2">
										<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" /></svg>
									</router-link>
									<button type="button" class="btn btn-sm btn-danger" @click="onDelete">
										<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
									</button>
								</div>
							</div>
							<div class="blog-detail-wrapper bg-white">
								<div class="main-image mb-32">
									<img :src="'/'+item?.poster" alt="" class="w-100 br-15">
								</div>
								<div class="d-flex align-items-center gap-16 mb-16">
									<img src="/assets/media/icons/calender.png" alt="">
									<p class="fw-500 dark-black">{{formatDate(item?.date, 'DD.MM.YYYY в HH:mm')}}</p>
								</div>
								<h3 class="mb-16 fw-700">{{item?.title}}</h3>
								<p v-html="item?.description"></p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- Blog Detail Section End -->
		</div>
		
		<benefits />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		loading: true,
		
		item: null,
	}),
	methods: {
		formatDate: lib.formatDate,
		
		async loadNewsItem(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetNewsitem(this.$route.params.id);
			if(ret.success){
				this.item = ret.item;
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данную новость?')){
				const ret = await this.appModel.doDeleteNewsItem(this.$route.params.id);
				if(ret.success){
					this.$router.push('/news');
				} else {
					alert(ret.error);
				}
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.loadNewsItem();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits
	},
};
</script>